import {Component, Vue} from "vue-property-decorator";
import {createAdvancedSearchFilters} from "@/components/providers/models/ProviderAdvancedSearchModel";
import ProviderAdvancedSearchFields from "@/components/providers/ProviderAdvancedSearchFields";

@Component({
  components: {
    ProviderAdvancedSearchFields
  }
})
export default class ProviderReport extends Vue {
  inputParams = { advancedSearchFilters: createAdvancedSearchFilters()};

  get inputParamsValid(): boolean {
    return true;
  }

  clearInputParams() {
    this.inputParams = { advancedSearchFilters: createAdvancedSearchFilters()};
  }

  getClass(rowName: string, cell: any) {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/components/reports/providers/ProviderReport.ts